import * as Yup from 'yup';
import { getPasswordRules, validatePassword } from 'utils/passwordRules';

const confirmResetPasswordSchema = (t, { email, mobilePhoneNumber }) =>
  Yup.object({
    password: Yup.string()
      .required(t('confirmResetPassword.errors.passwordRequired'))
      .test('password-validations', t('confirmResetPassword.errors.invalidPassword'), function (value) {
        return validatePassword(value, { email, mobilePhoneNumber }, getPasswordRules(t));
      }),
    confirmPassword: Yup.string()
      .required(t('confirmResetPassword.errors.confirmPasswordRequired'))
      .oneOf([Yup.ref('password'), null], t('confirmResetPassword.errors.confirmPasswordMismatch')),
  });

export default confirmResetPasswordSchema;
